import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { OLTCardManagementPage } from '@/features/devices'

export const Route = createFileRoute('/_authenticated/devices/olt-cards')({
  component: () => (
    <RequirePermission permission='olts.read'>
      <OLTCardManagementPage />
    </RequirePermission>
  ),
})
